@if (open) {
  <div @slideUpDown (@slideUpDown.done)="onAnimationEvent()" (@slideUpDown.start)="announce()">
    <div class="backdrop" (click)="close.emit()"></div>
    <div class="overlay">
      <div class="panel" #panelRef>
        <button
          class="close"
          [stbButton]="'text'"
          [rebrand]="true"
          [size]="'small'"
          role="button"
          [attr.aria-label]="'simulationParamsPanel.close.label' | fms"
          (click)="close.emit()"
          [iconType]="'close'"
          [setIconAfter]="true"
        ></button>
        <app-simulation-age (selectionChange)="close.emit()"></app-simulation-age>
      </div>
    </div>
  </div>
}
